import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { actions } from "store"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { markingWordsSaveDraftFetch } from "store/middlewares/markingWords.crud"
import { saveWordsFetch } from "store/middlewares/words.crud"
import { surferHooks } from 'components/Record';
import { queryClient as qc } from 'keys'
import { markingWordsHooks } from ".."
import { toast } from "react-toastify"
import { toastConfig } from "config"

const useSaveDraft = () => {
    const dispatch = useDispatch()
    const queryClient = useQueryClient()

    const isTraining = markingWordsHooks.useIsTraining()

    const onPause = surferHooks.useOnPause()
    const { save, loading: saveLoading } = markingWordsHooks.useSave()

    const { assessment } = useSelector(state => state.assessment)

    const { mutateAsync: markingWordsSaveDraftRQ, isPending: markingWordsSaveDraftLoading } = useMutation({ mutationFn: markingWordsSaveDraftFetch })
    const { mutateAsync: saveWordsRQ, isPending: saveWordsLoading } = useMutation({ mutationFn: saveWordsFetch })

    const markingWordsSaveDraft = async () => {
        if (!assessment.timePoint?.word_def_id)
            toast.error("אנא הכנס נקודת זמן", toastConfig)

        onPause()
        const data = await save()
        if (data) {
            await markingWordsSaveDraftRQ({ id: assessment.id, data, isTrainingAssessment: isTraining })
            queryClient.invalidateQueries({ queryKey: [qc.assessmentAndWords] })

            dispatch(actions.setIsCloseSttoper(true))
        }
    }

    return {
        saveDraft: markingWordsSaveDraft,
        loading: markingWordsSaveDraftLoading || saveWordsLoading
    }
}

export default useSaveDraft